export function maxLength(q, max = 50) {
  if (q.length <= max) return q;
  return q.substr(0, max) + "...";
}

export function formatName ({ firstname = "", lastname = "" }){
  const names = firstname.split(" ");
  return `${names[0]} ${lastname[0].toUpperCase()}.`;
}